/**
 * useSubmitWorkflowRun — submit a workflow run to the cortex_tasks queue.
 *
 * Thin React wrapper around the shared submitWorkflowRun core from
 * @flowstate/quick-actions. Injects flowstate-start's auth + org context.
 */

import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { useCurrentOrganizationId } from "@/hooks/useCurrentOrganization";
import { submitWorkflowRun, type SubmitWorkflowRunResult } from "@flowstate/quick-actions";

export function useSubmitWorkflowRun() {
  const { user } = useAuth();
  const orgId = useCurrentOrganizationId();

  const submit = useCallback(
    async (workflowId: string, inputs?: Record<string, unknown>): Promise<SubmitWorkflowRunResult> => {
      if (!user?.id) return { error: "Not authenticated" };
      return submitWorkflowRun({
        supabase,
        userId: user.id,
        orgId: orgId ?? null,
        workflowId,
        inputs,
      });
    },
    [user?.id, orgId]
  );

  return { submitWorkflowRun: submit };
}
